// import store from "../store";
import { fetch as fetchPolyfill } from "whatwg-fetch";
import ErrorService from "./ErrorService";
import JSZip from "jszip/dist/jszip";
import JSZipUtils from "jszip-utils";
import Utils from "../helpers/utils";
import store from "../store";
var JSONbig = require('json-bigint');

export default class BaseService {
  getZipBinaryContent(url) {
    return new Promise((resolve, reject) => {
      fetch(url)
        .then((response) => {
          //TODO: check why status 0 is also ok
          if (response.status === 200 || response.status === 0) {
            store.commit("setUserIP", response.headers.get("IP"));
            store.commit("setUserTenant", response.headers.get("Tenant"));
            store.commit("setUserTenantID", response.headers.get("TenantID"));
            store.commit("setCaptchaConfig", response.headers.get("CaptchaConfig"));
            return resolve(response.blob());
          } else {
            response.json().then((res) => {
              return reject(res.message);
            });
          }
        })
        .catch((e) => {
          throw e;
        });
    });
  }
  prepareFilesAtZip(relativePath, file) {
    return new Promise((resolve) => {
      file.async("string").then((text) => {
        resolve({ fileName: relativePath, text });
      });
    });
  }
  async getAppData(url) {
    try {
      let data, zip;
      data = await this.getZipBinaryContent(url);
      zip = await JSZip.loadAsync(data);
      let promises = [];
      zip.folder("").forEach((relativePath, file) => {
        promises.push(this.prepareFilesAtZip(relativePath, file));
      });
      return await Promise.all(promises);
    } catch (e) {
      throw new Error(e);
    }
  }
  getDefaultPostObj(body) {
    return {
      cache: "no-cache",
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
    };
  }
  isJson(str) {
    try {
      //json parse with remove new line
      JSON.parse(str.replace(/(\r\n|\n|\r)/gm, ""));
    } catch (e) {
      return false;
    }
    return true;
  }
  handleBadEstimatedTime(result) {
    Utils.log.error(
      "Wrong JSON format parsing. Trying to bypass by UI, the value can still stay incorrect. (Could be wrong 'Estimated_Time' value)."
    );
    let estimatedIndex = result.indexOf("Estimated_Time");
    let AdditionalIndex = result.indexOf("Additional_Information");
    let bindex = estimatedIndex;
    let eindex = AdditionalIndex;
    let modifiedJSON = result.replace(result.substring(bindex, eindex), "");
    if (this.isJson(modifiedJSON)) {
      return modifiedJSON;
    }
    return result;
  }
  handleBadJSON(result) {
    result = this.handleBadEstimatedTime(result);
    Utils.log.info("After UI parsing, data is: ", result);
    if (this.isJson(result)) {
      return JSON.parse(result.replace(/(\r\n|\n|\r)/gm, ""));
    } else {
      throw result;
    }
  }
  async performRequest(url, body, alertErrors = true) {
    Utils.log.debug("performRequest starting:" + url);
    let result = null;
    try {
      const response = await fetchPolyfill(url, body);
      Utils.log.debug("performRequest response:" + JSON.stringify(response));
      if (response && response.status && response.status >= 500 && response.status < 600) {
        Utils.log.error("performRequest Server error " + response.status + " - setting disconnected");
        store.commit("setConnId", -1);
        if (store.getters.widgetData.config.externalController == true)
          window.parent.postMessage({CC:{"leaveChat":true}}, "*");
      }
      result = await response.text();
      try {
        // For using SC for joinChat to know which server was used
        var server = response.headers.get('CCUServerAddress');
        if (server && server != '') {
          Utils.log.debug("CCUServerAddress in header:" + server);
          store.commit("setCCUServerAddress", server);
        }
      } catch (err) {}
      if (result) result = result.replace(/\t/g, ' ');
      if (this.isJson(result)) {
        Utils.log.debug("Response:" + result);
        //result = JSON.parse(result.replace(/(\r\n|\n|\r)/gm, ""));
        result = JSONbig.parse(result.replace(/(\r\n|\n|\r)/gm, ""));
        //Utils.postMessageObject("ccsp", result);
      } else {
        result = this.handleBadJSON(result);
      }
      Utils.log.debug("performRequest returning:" + JSON.stringify(result));
      return result;
    } catch (e) {
      Utils.log.debug("performRequest error:" + JSON.stringify(e));
      //if isn't e.message send e
      if (alertErrors === true) {
        Utils.postMessageObject("error", e.message || e);
        ErrorService.displayAlert(e.message || e);
      }
      throw new Error(e);
    }
  }
}
